import { Injectable } from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { TypeParams } from './types'

/** @see {@link ec.models.Api} */
@Injectable({ providedIn: 'root' })
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context => {
      if (!context) {
        return rxjs.of([])
      }

      return gql.queries.scenarios
        .execute(context)
        .pipe(rxjs.map(({ items }) => items))
    },
  )

  /** @inheritdoc */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of([
      ec.models.Attribute.fromKey<TypeParams>('name', {
        isSortable: true,
        name: 'Name',
      }),
      ec.models.Attribute.fromKey<TypeParams>('alias', {
        isSortable: true,
        name: 'Alias',
      }),
      ec.models.Attribute.fromKey<TypeParams>('description', {
        name: 'Description',
      }),
      {
        getValueFrom: entity => ents.core.admin.Scenario.getPeriodRange(entity),
        id: 'activePeriod',
        name: 'Active Period',
        valueInfo: {
          type: ents.core.common.value.types.Intrinsic.DateRange,
        },
      },
    ])
}
